module.exports = __webpack_public_path__ + "static/media/gal-1.581fc6ad.jpeg";